import React from 'react';

function MyAvatar() {
  return (
    <img
      className="avatar-photo"
      src="/avatar/samet.png"
      alt="Samet Aslan"
      width={180}
      height={191}
    />
  );
}

export default MyAvatar;
